import { LionInputStepper } from '../input-stepper.js';

customElements.define('lion-input-stepper', LionInputStepper);
